import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const inventoryInitialValue = {
  name: "",
};

export const inventoryValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type InventoryValues = typeof inventoryInitialValue;

export const inventoryItemInitialValue = {
  name: "",
  nro: "",
  inventoryId: undefined,
};

export const inventoryItemValidationSchema = Yup.object({
  inventoryId: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  nro: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type InventoryItemValues = typeof inventoryItemInitialValue;
